<template>
    <div>
        <v-overlay :value="loading.data" opacity="0" z-index="4">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary">
            </v-progress-circular>
        </v-overlay>
        <v-card
            flat
            v-if="!loading.data">
            <v-card-title>
                {{ $t('TIRE_BRANDS_PAGE_TITLE') }}
                <v-spacer></v-spacer>
                <v-text-field
                    :label="$t('TIRE_BRANDS_SEARCH')"
                    v-model="search"
                    hide-details
                    class="ml-4">
                </v-text-field>
                <v-btn
                    small
                    fab
                    color="primary"
                    class="ml-2"
                    @click="openTireBrandDialog({editMode: false})">
                    <v-icon>mdi-plus-circle</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-subtitle>{{ $t('TIRE_BRANDS_SUBTITLE') }}</v-card-subtitle>
            <v-card-text>
                <v-data-table
                    :items="tireBrands"
                    :headers="headers.tireBrands"
                    :search="search">
                    <template v-slot:item.actions="{item}">
                        <v-menu>
                            <template v-slot:activator="{on}">
                                <v-btn
                                    icon
                                    small
                                    v-on="on">
                                    <v-icon>mdi-dots-horizontal</v-icon>
                                </v-btn>
                            </template>
                            <v-card>
                                <v-subheader>{{ $t('ACTIONS_MENU_TITLE') }}</v-subheader>
                                <v-list dense>
                                    <v-list-item
                                        v-if="authorizations.tire_brands.update"
                                        link
                                        @click="openTireBrandDialog({editMode: true, id: item.id})"
                                        :disabled="!item.meta.editable">
                                        <v-list-item-avatar>
                                            <v-icon :disabled="!item.meta.editable">mdi-pencil</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ $t('ACTIONS_MENU_EDIT') }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="authorizations.tire_brands.delete"
                                        link
                                        @click="openDeleteTireBrandDecisionDialog(item.id)"
                                        :disabled="!item.meta.deletable">
                                        <v-list-item-avatar>
                                            <v-icon :disabled="!item.meta.deletable">mdi-delete</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ $t('ACTIONS_MENU_DELETE') }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-card>
                        </v-menu>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>
        <TireBrandDialog
            ref="tireBrandDialog"/>
        <DecisionDialog
            ref="decisionDialog"
            @submit="submitDecisionDialog"/>
        <AlertDialog
            ref="alertDialog"/> 
    </div>
</template>

<script>
import TireBrandDialog from '../components/TireBrandDialog';
import DecisionDialog from '../components/DecisionDialog';
import AlertDialog from '../components/AlertDialog';
import { mapActions, mapState } from 'vuex';

export default {
    name: "TireBrands",
    components: {
        TireBrandDialog,
        DecisionDialog,
        AlertDialog
    },
    data() {
        return {
            headers: {
                tireBrands: [
                    {text: "ID", value: "id"},
                    {text: this.$t('TIRE_BRAND_NAME'), value: "name"},
                    {text: this.$t("ACTIONS_MENU_TITLE"), value: "actions"}
                ]
            },
            loading: {
                data: true
            },
            search: null
        }
    },
    computed: {
        ...mapState("tireBrand", ["tireBrands"]),
        ...mapState("authentication", ["authorizations"])
    },
    methods: {
        ...mapActions("tireBrand", ["fetchTireBrands", "removeTireBrand"]),
        openTireBrandDialog(params) {
            this.$refs.tireBrandDialog.open(params);
        },
        openDeleteTireBrandDecisionDialog(id) {
            this.$refs.decisionDialog.open({
                title: this.$t('DELETE_CONFIRM_TITLE'),
                content: this.$t('DELETE_CONFIRM_CONTENT'),
                action: "DELETE_TIRE_BRAND",
                id: id
            });
        },
        submitDecisionDialog(params) {
            if(params.action == "DELETE_TIRE_BRAND") {
                this.removeTireBrand(params.id)
                    .then(response => {
                        this.$refs.alertDialog.open(this.$t('SUCCESS_TITLE'), response.message);
                        this.fetchTireBrands();
                    })
                    .catch(error => {
                        this.$refs.alertDialog.open(this.$t('ERROR_TITLE'), error.message);
                    });
            }
        }
    },
    async created() {
        await this.fetchTireBrands();
        this.loading.data = false;
    }
}
</script>